import React from "react";
import { map } from "lodash";

import PageHeader from "~/components/PageHeader";

const getEnglishBreadcrumbs = (primaryCategory, category) => {
    const crumbs = [
        {
            pathname: "/",
            crumbLabel: "Home",
        },
        {
            pathname: `/products/`,
            crumbLabel: "Products",
        },
        {
            pathname: `/products/${primaryCategory.slug}/`,
            crumbLabel: primaryCategory.title,
        },
        {
            crumbLabel: category.title,
        },
    ];

    return crumbs;
};

const ProductCategoryPageHeader = ({ data, urlPermutations }) => {
    const {
        parentCategory,
        wpProductCategory: { title, slug, description, categoryData },
    } = data;

    const { productCarouselImages, productCarouselShowCaptions } =
        categoryData || {};

    const productImages = map(productCarouselImages, (img) => {
        return {
            showCaption: productCarouselShowCaptions,
            image: {
                ...img,
            },
        };
    });

    return (
        <PageHeader
            {...{ title, urlPermutations }}
            sectionId={categoryData.pageHeaderSectionId}
            crumbs={getEnglishBreadcrumbs(parentCategory, {
                title,
                slug,
            })}
            lastCrumbLabel={title}
            links={categoryData.landingPageLinks}
            copy={description}
            moreText={categoryData.readMore}
            subtitle={parentCategory.title}
            noMarginBottom={
                !!categoryData.displayDisclaimer ||
                categoryData.jumpLinks?.length > 0
            }
            image={
                categoryData.productCarouselImages?.length
                    ? categoryData.productCarouselImages[0]
                    : null
            }
            productImages={productImages}
            isProductCategoryPage={true}
        />
    );
};

export default ProductCategoryPageHeader;
